"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ORGANIZATIONS_DATA = exports.EGenders = exports.OFFLINE_SCHOOL_PAGE_TYPE = exports.UNIVERSITY_PAGE_TYPE = exports.BANKRUPTCY_PAGE_TYPE = exports.MARKETPLACE_PAGE_TYPE = exports.LEASING_PAGE_TYPE = exports.NPF_PAGE_TYPE = exports.BOOKMAKER_PAGE_TYPE = exports.BROKER_PAGE_TYPE = exports.SCHOOL_PAGE_TYPE = exports.MFO_PAGE_TYPE = exports.INSURANCE_COMPANY_PAGE_TYPE = exports.BANKS_PAGE_TYPE = exports.PAGE_TYPE = void 0;
const types_1 = require("./types");
var PAGE_TYPE;
(function (PAGE_TYPE) {
    PAGE_TYPE["Bank"] = "bank";
    PAGE_TYPE["Banki"] = "banki";
    PAGE_TYPE["Banks"] = "banks";
    PAGE_TYPE["StrakhovajaKompanija"] = "strakhovaja-kompanija";
    PAGE_TYPE["StrakhovyeKompanii"] = "strakhovye-kompanii";
    PAGE_TYPE["InsuranceCompany"] = "insuranceCompany";
    PAGE_TYPE["Insurance"] = "insurance";
    PAGE_TYPE["Zaimy"] = "zaimy";
    PAGE_TYPE["MikrofinansovyeOrganizacii"] = "mikrofinansovye-organizacii";
    PAGE_TYPE["MikrofinansovajaOrganizacija"] = "mikrofinansovaja-organizacija";
    PAGE_TYPE["Mfi"] = "mfi";
    PAGE_TYPE["Mfo"] = "mfo";
    PAGE_TYPE["Shkoly"] = "shkoly";
    PAGE_TYPE["Shkola"] = "shkola";
    PAGE_TYPE["Kursy"] = "kursy";
    PAGE_TYPE["EducationalOrganization"] = "educationalOrganization";
    PAGE_TYPE["Broker"] = "broker";
    PAGE_TYPE["Brokery"] = "brokery";
    PAGE_TYPE["Bukmeker"] = "bukmeker";
    PAGE_TYPE["Bukmekery"] = "bukmekery";
    PAGE_TYPE["Bookmaker"] = "bookmaker";
    PAGE_TYPE["Npf"] = "npf";
    PAGE_TYPE["Leasing"] = "leasing";
    PAGE_TYPE["Marketplace"] = "marketplace";
    PAGE_TYPE["Bankruptcy"] = "bankruptcy";
    PAGE_TYPE["University"] = "university";
    PAGE_TYPE["OfflineSchoolType"] = "offlineSchool";
    PAGE_TYPE["OfflineSchool"] = "offline-school";
})(PAGE_TYPE = exports.PAGE_TYPE || (exports.PAGE_TYPE = {}));
exports.BANKS_PAGE_TYPE = [PAGE_TYPE.Bank, PAGE_TYPE.Banki, PAGE_TYPE.Banks];
exports.INSURANCE_COMPANY_PAGE_TYPE = [
    PAGE_TYPE.StrakhovajaKompanija,
    PAGE_TYPE.StrakhovyeKompanii,
    PAGE_TYPE.InsuranceCompany,
    PAGE_TYPE.Insurance,
];
exports.MFO_PAGE_TYPE = [
    PAGE_TYPE.Mfi,
    PAGE_TYPE.Mfo,
    PAGE_TYPE.Zaimy,
    PAGE_TYPE.MikrofinansovajaOrganizacija,
    PAGE_TYPE.MikrofinansovyeOrganizacii,
];
exports.SCHOOL_PAGE_TYPE = [
    PAGE_TYPE.Shkoly,
    PAGE_TYPE.Shkola,
    PAGE_TYPE.EducationalOrganization,
    PAGE_TYPE.Kursy,
];
exports.BROKER_PAGE_TYPE = [PAGE_TYPE.Brokery, PAGE_TYPE.Broker];
exports.BOOKMAKER_PAGE_TYPE = [PAGE_TYPE.Bukmekery, PAGE_TYPE.Bukmeker, PAGE_TYPE.Bookmaker];
exports.NPF_PAGE_TYPE = [PAGE_TYPE.Npf];
exports.LEASING_PAGE_TYPE = [PAGE_TYPE.Leasing];
exports.MARKETPLACE_PAGE_TYPE = [PAGE_TYPE.Marketplace];
exports.BANKRUPTCY_PAGE_TYPE = [PAGE_TYPE.Bankruptcy];
exports.UNIVERSITY_PAGE_TYPE = [PAGE_TYPE.University];
exports.OFFLINE_SCHOOL_PAGE_TYPE = [PAGE_TYPE.OfflineSchool, PAGE_TYPE.OfflineSchoolType];
var EGenders;
(function (EGenders) {
    EGenders["FEMININE"] = "feminine";
    EGenders["MASCULINE"] = "masculine";
    EGenders["NEUTER"] = "neuter";
})(EGenders = exports.EGenders || (exports.EGenders = {}));
exports.ORGANIZATIONS_DATA = {
    [types_1.OrganizationTypes.Bank]: {
        typeForService: types_1.OrganizationTypes.Bank,
        listTypeUrl: PAGE_TYPE.Banki,
        itemTypeUrl: PAGE_TYPE.Bank,
        logoTypeUrl: 'banks',
        ratingUrl: `/${PAGE_TYPE.Banki}/rating/`,
        reviewService: types_1.ReviewObjectTypes.Banks,
        seoService: 'bank',
        dfpCategory: 'banks',
        dfpProduct: 'none',
        namesType: {
            bigFirstChar: 'Банк',
            bigFirstCharMulti: 'Банки',
            smallFirstChar: 'банк',
            mode: 'банка',
            mode2: 'банком',
            mode3: 'банковские',
            mode4: 'банковских',
            mode5: 'банк',
            mode6: 'банке',
            mode7: 'банков',
            mode8: 'банках',
            mode9: 'банков',
            mode10: 'банка',
            adjective: 'финансовым',
            serviceDative: 'банковским услугам',
            gender: EGenders.MASCULINE,
        },
    },
    [types_1.OrganizationTypes.Insurance]: {
        oldOrgType: 'insuranceCompany',
        typeForService: types_1.OrganizationTypes.Insurance,
        listTypeUrl: PAGE_TYPE.StrakhovyeKompanii,
        itemTypeUrl: PAGE_TYPE.StrakhovajaKompanija,
        logoTypeUrl: 'ic',
        ratingUrl: `/${PAGE_TYPE.StrakhovyeKompanii}/rating/`,
        seoService: 'insurancecompany',
        reviewService: types_1.ReviewObjectTypes.InsuranceCompany,
        dfpCategory: 'insurance',
        dfpProduct: 'none',
        namesType: {
            bigFirstChar: 'Страховая компания',
            bigFirstCharMulti: 'Страховые компании',
            smallFirstChar: 'страховая компания',
            mode: 'страховой компании',
            mode2: 'страховой компанией',
            mode3: 'страховые',
            mode4: 'страховых',
            mode5: 'страховую компанию',
            mode6: 'страховой компании',
            mode7: 'страховых компаний',
            mode8: 'страховых компаниях',
            mode9: 'страховых компаний',
            mode10: 'страховые компании',
            adjective: 'страховым',
            serviceDative: 'страховым услугам',
            gender: EGenders.FEMININE,
        },
    },
    [types_1.OrganizationTypes.Mfo]: {
        typeForService: types_1.OrganizationTypes.Mfo,
        listTypeUrl: PAGE_TYPE.Zaimy,
        itemTypeUrl: PAGE_TYPE.Zaimy,
        logoTypeUrl: 'mfi',
        ratingUrl: `/${PAGE_TYPE.Zaimy}/rating-mfo/`,
        reviewService: types_1.ReviewObjectTypes.Mfi,
        seoService: 'MicrofinanceOrganization',
        // категории mfo нет поэтому ставим banks
        dfpCategory: 'banks',
        dfpProduct: 'none',
        namesType: {
            bigFirstChar: 'Микрофинансовая организация',
            bigFirstCharMulti: 'Микрофинансовые организации',
            smallFirstChar: 'микрофинансовая организация',
            mode: 'микрофинансовой организации',
            mode2: 'микрофинансовой организацией',
            mode3: 'микрофинансовые',
            mode4: 'микрофинансовых',
            mode5: 'микрофинансовую организацию',
            mode6: 'микрофинансовой организации',
            mode7: 'микрофинансовых организаций',
            mode8: 'микрофинансовых организациях',
            mode9: 'микрофинансовых организаций',
            mode10: 'микрофинансовые организации',
            adjective: 'микрофинансовым',
            serviceDative: 'услугам МФО',
            gender: EGenders.FEMININE,
        },
    },
    [types_1.OrganizationTypes.EducationalOrganization]: {
        typeForService: types_1.OrganizationTypes.EducationalOrganization,
        listTypeUrl: PAGE_TYPE.Kursy,
        itemTypeUrl: PAGE_TYPE.Shkola,
        // logoTypeUrl: 'mfi',
        ratingUrl: `/${PAGE_TYPE.Kursy}/rating/`,
        reviewService: types_1.ReviewObjectTypes.EducationalOrganization,
        // seoService: 'MicrofinanceOrganization',
        // категории school нет поэтому ставим banks
        dfpCategory: 'banks',
        dfpProduct: 'education',
        namesType: {
            bigFirstChar: 'Онлайн-школа',
            bigFirstCharMulti: 'Образовательные организации',
            smallFirstChar: 'онлайн-школа',
            mode: 'онлайн-школы',
            mode2: 'онлайн-школой',
            mode3: 'образовательные',
            mode4: 'образовательных',
            mode5: 'онлайн-школу',
            mode6: 'онлайн-школе',
            mode7: 'онлайн-школой',
            mode8: 'онлайн-школах',
            mode9: 'онлайн-школ',
            mode10: 'онлайн-школы',
            adjective: 'образовательным',
            serviceDative: 'направлениям',
            gender: EGenders.FEMININE,
        },
    },
    [types_1.OrganizationTypes.Broker]: {
        typeForService: types_1.OrganizationTypes.Broker,
        listTypeUrl: PAGE_TYPE.Brokery,
        itemTypeUrl: PAGE_TYPE.Broker,
        logoTypeUrl: 'banks',
        ratingUrl: `/${PAGE_TYPE.Brokery}/rating/`,
        reviewService: types_1.ReviewObjectTypes.Broker,
        seoService: 'broker',
        dfpCategory: 'banks',
        dfpProduct: 'none',
        namesType: {
            bigFirstChar: 'Брокер',
            bigFirstCharMulti: 'Брокеры',
            smallFirstChar: 'брокер',
            mode: 'брокера',
            mode2: 'брокером',
            mode3: 'брокерские',
            mode4: 'брокерских',
            mode5: 'брокер',
            mode6: 'брокере',
            mode7: 'брокеров',
            mode8: 'брокерах',
            mode9: 'брокеров',
            mode10: 'брокера',
            adjective: 'брокерским',
            serviceDative: 'брокерским услугам',
            gender: EGenders.MASCULINE,
        },
    },
    [types_1.OrganizationTypes.Npf]: {
        typeForService: types_1.OrganizationTypes.Npf,
        listTypeUrl: PAGE_TYPE.Npf,
        itemTypeUrl: PAGE_TYPE.Npf,
        logoTypeUrl: 'banks',
        ratingUrl: `/${PAGE_TYPE.Npf}/rating/`,
        reviewService: types_1.ReviewObjectTypes.Npf,
        seoService: 'npf',
        dfpCategory: 'banks',
        dfpProduct: 'none',
        namesType: {
            bigFirstChar: 'НПФ',
            bigFirstCharMulti: 'НПФ',
            smallFirstChar: 'фонд',
            mode: 'фонда',
            mode2: 'фондом',
            mode3: 'пенсионные',
            mode4: 'пенсионных',
            mode5: 'фонд',
            mode6: 'фонде',
            mode7: 'фондов',
            mode8: 'фондах',
            mode9: 'фондов',
            mode10: 'фонда',
            adjective: 'пенсионным',
            serviceDative: 'услугам фондов',
            gender: EGenders.MASCULINE,
        },
    },
    [types_1.OrganizationTypes.Leasing]: {
        typeForService: types_1.OrganizationTypes.Leasing,
        listTypeUrl: PAGE_TYPE.Leasing,
        itemTypeUrl: PAGE_TYPE.Leasing,
        ratingUrl: `/${PAGE_TYPE.Leasing}/rating/`,
        reviewService: types_1.ReviewObjectTypes.Leasing,
        seoService: 'leasing',
        dfpCategory: 'banks',
        dfpProduct: 'none',
        namesType: {
            bigFirstChar: 'Лизинговая компания',
            bigFirstCharMulti: 'Лизинговые компании',
            smallFirstChar: 'лизинговая компания',
            mode: 'лизинговой компании',
            mode2: 'лизинговая компанией',
            mode3: 'лизинговые',
            mode4: 'лизинговых',
            mode5: 'лизинговую компанию',
            mode6: 'лизинговой компании',
            mode7: 'лизинговых компаний',
            mode8: 'лизинговых компаниях',
            mode9: 'лизинговых компаний',
            mode10: 'лизинговые компании',
            adjective: 'лизинговым',
            serviceDative: 'лизинговым услугам',
            gender: EGenders.FEMININE,
        },
    },
    [types_1.OrganizationTypes.Marketplace]: {
        typeForService: types_1.OrganizationTypes.Marketplace,
        listTypeUrl: PAGE_TYPE.Marketplace,
        itemTypeUrl: PAGE_TYPE.Marketplace,
        ratingUrl: `/${PAGE_TYPE.Marketplace}/rating/`,
        reviewService: types_1.ReviewObjectTypes.Marketplace,
        seoService: 'marketplace',
        dfpCategory: 'banks',
        dfpProduct: 'none',
        namesType: {
            bigFirstChar: 'Маркетплейс',
            bigFirstCharMulti: 'Маркетплейсы',
            smallFirstChar: 'маркетплейс',
            mode: 'маркетплейса',
            mode2: 'маркетплейсом',
            mode3: 'маркетплейсовые',
            mode4: 'маркетплейсовых',
            mode5: 'маркетплейс',
            mode6: 'маркетплейсе',
            mode7: 'маркетплейсов',
            mode8: 'маркетплейсах',
            mode9: 'маркетплейсов',
            mode10: 'маркетплейса',
            adjective: 'маркетплейсовым',
            serviceDative: 'услугам на маркетплейсах',
            gender: EGenders.MASCULINE,
        },
    },
    [types_1.OrganizationTypes.Bankruptcy]: {
        typeForService: types_1.OrganizationTypes.Bankruptcy,
        listTypeUrl: PAGE_TYPE.Bankruptcy,
        itemTypeUrl: PAGE_TYPE.Bankruptcy,
        ratingUrl: `/${PAGE_TYPE.Bankruptcy}/rating/`,
        reviewService: types_1.ReviewObjectTypes.Bankruptcy,
        seoService: 'bankruptcy',
        dfpCategory: 'banks',
        dfpProduct: 'none',
        namesType: {
            bigFirstChar: 'Компания по банкротству',
            bigFirstCharMulti: 'Компании по банкротству',
            smallFirstChar: 'компания по банкротству',
            mode: 'компании по банкротству',
            mode2: 'компанией по банкротству',
            mode3: 'банкротские',
            mode4: 'банкротских',
            mode5: 'компанию по банкротству',
            mode6: 'компании по банкротству',
            mode7: 'компаний по банкротству',
            mode8: 'компаниях по банкротству',
            mode9: 'компаний по банкротству',
            mode10: 'компании по банкротству',
            adjective: 'банкротским',
            serviceDative: 'услугам банкротства',
            gender: EGenders.FEMININE,
        },
    },
    [types_1.OrganizationTypes.University]: {
        typeForService: types_1.OrganizationTypes.University,
        listTypeUrl: PAGE_TYPE.University,
        itemTypeUrl: PAGE_TYPE.University,
        ratingUrl: `/${PAGE_TYPE.University}/rating/`,
        reviewService: types_1.ReviewObjectTypes.University,
        seoService: 'university',
        dfpCategory: 'banks',
        dfpProduct: 'none',
        namesType: {
            bigFirstChar: 'Вуз',
            bigFirstCharMulti: 'Вузы',
            smallFirstChar: 'вуз',
            mode: 'вуза',
            mode2: 'вузом',
            mode3: 'образовательные',
            mode4: 'образовательных',
            mode5: 'вуз',
            mode6: 'вузе',
            mode7: 'вузов',
            mode8: 'вузах',
            mode9: 'вузов',
            mode10: 'вуза',
            adjective: 'образовательным',
            serviceDative: 'услугам вузов',
            gender: EGenders.MASCULINE,
        },
    },
    [types_1.OrganizationTypes.OfflineSchool]: {
        typeForService: types_1.OrganizationTypes.OfflineSchool,
        listTypeUrl: PAGE_TYPE.OfflineSchool,
        itemTypeUrl: PAGE_TYPE.OfflineSchool,
        ratingUrl: `/${PAGE_TYPE.OfflineSchool}/rating/`,
        reviewService: types_1.ReviewObjectTypes.OfflineSchool,
        seoService: 'offlineSchool',
        dfpCategory: 'banks',
        dfpProduct: 'education',
        namesType: {
            bigFirstChar: 'Школа',
            bigFirstCharMulti: 'Школы',
            smallFirstChar: 'школа',
            mode: 'школы',
            mode2: 'школой',
            mode3: 'образовательные',
            mode4: 'образовательных',
            mode5: 'школу',
            mode6: 'школе',
            mode7: 'школой',
            mode8: 'школах',
            mode9: 'школ',
            mode10: 'школы',
            adjective: 'образовательным',
            serviceDative: 'направлениям',
            gender: EGenders.FEMININE,
        },
    },
    [types_1.OrganizationTypes.Bookmaker]: {
        typeForService: types_1.OrganizationTypes.Bookmaker,
        listTypeUrl: PAGE_TYPE.Bukmekery,
        itemTypeUrl: PAGE_TYPE.Bukmeker,
        ratingUrl: `/${PAGE_TYPE.Bukmekery}/rating/`,
        reviewService: types_1.ReviewObjectTypes.Bookmaker,
        seoService: 'bookmaker',
        dfpCategory: 'banks',
        dfpProduct: 'none',
        namesType: {
            bigFirstChar: 'Букмекер',
            bigFirstCharMulti: 'Букмекеры',
            smallFirstChar: 'букмекер',
            mode: 'букмекера',
            mode2: 'букмекером',
            mode3: 'букмекерские',
            mode4: 'букмекерских',
            mode5: 'букмекер',
            mode6: 'букмекере',
            mode7: 'букмекеров',
            mode8: 'букмекерах',
            mode9: 'букмекеров',
            mode10: 'букмекера',
            adjective: 'букмекерским',
            serviceDative: 'букмекерским услугам',
            gender: EGenders.MASCULINE,
        },
    },
};
